module.exports = __webpack_public_path__ + "static/media/img-lang-ja.43cdccdd.svg";